import { render } from "./EnCopyrightView.vue?vue&type=template&id=108407ef&scoped=true"
import script from "./EnCopyrightView.vue?vue&type=script&lang=js"
export * from "./EnCopyrightView.vue?vue&type=script&lang=js"

import "../assets/css/common.css?vue&type=style&index=0&lang=css"
import "../assets/css/en/Privacy.css?vue&type=style&index=1&id=108407ef&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\project\\national-museum-website\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-108407ef"]])

export default __exports__